import angular from 'angular';
import { localStorage } from '../../utils';
import { get, isNull } from 'lodash';
import '../../app.constants';
import '../../services/globals';
import '../../services/organization';
import '../../services/place';
import '../../services/user';
import '../../services/redirect-to-new-version';
import '../../services/errors';
import '../../services/queue';
import '../../services/notifications';
import '../../resources/resource';
import '../modals/places';
import Roles from '../../enums/roles';
import { CallingAutomaticallyStatus, CallingAutomaticallyReason } from '../../enums/callingAutomatically';

const module = angular.module('whyline.controllers.places.list', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.organization',
  'whyline.services.place',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.queue',
  'whyline.services.notifications',
  'whyline.services.redirect-to-new-version',
  'whyline.resources.resource',
  'whyline.modals.place',
]);

const PlacesListController = (SAFE_STATES, $scope, $rootScope, $state, $timeout, $uibModal, PlaceService, UserService, GlobalsService, ErrorService, QueueService, NotificationService, OrganizationService, RedirectToNewVersionService, $translate) => {
  /*@ngInject*/

  GlobalsService.SetCurrentPlace(null);
  $rootScope.$on('update-all-places-in-place-list', async () => {
    const placesPromise = $scope.superAdmin ? PlaceService.GetAllEnterpriseAsPromise() : PlaceService.GetAllAsPromise();
    Promise.all([placesPromise]).then(([places]) => {
      $timeout(() => {
        $scope.places = places;
      })
    });
  });

  let user = localStorage.get('user');
  const userId = get(user, '_id', '');

  $scope.currentUser = user;
  $scope.superAdmin = user && user.sudo;
  $scope.showList = false;

  // Roles allowed to see the list of places
  const rolesAllowed = [Roles.organizationAdmin, Roles.adminGeneral];
  const rolesAllowedToEnableDisablePlace = [Roles.organizationAdmin, Roles.adminGeneral];

  const permissions = get(user, 'permissions', []) || [];
  const someRolAllowed = (permissions.map(permission => rolesAllowed.indexOf(permission.role.name) > -1)).some(Boolean);
  const showPlaces = ($scope.superAdmin || someRolAllowed) && !isNull(GlobalsService.SinglePlace);
  $scope.first_place = $translate.instant('first_place');
  $scope.showAdvancedSearch = false;

  $scope.queryOrganizationAndPlace = () => {
    const placesPromise = $scope.superAdmin ? PlaceService.GetAllEnterpriseAsPromise() : PlaceService.GetAllAsPromise();
    const organizationPromise = OrganizationService.GetCurrentAsPromise();
    Promise.all([placesPromise, organizationPromise]).then(([places, organization]) => {
      $timeout(() => {
        $scope.places = places;
        $scope.organization = organization;
        $scope.limits = {
          maxPlaces: organization.configuration.plan.maxPlaces,
          unlimited: organization.configuration.plan.maxPlaces === -1
        };
        $scope.imageSrc = organization.images.logo || organization.images.thumbnail || 'img/common/placeholder-place.png';
        if(Object.keys(places).length === 1 && !showPlaces && places[Object.keys(places)[0]].configuration.enabledForAppAndAgenda) {
          $scope.selectPlace(places[Object.keys(places)[0]]);
          GlobalsService.SetSinglePlace(true);
        } else {
          GlobalsService.SetSinglePlace(false);
          $scope.showList = true;
        }
      });
    })
    .catch(ErrorService.handler);
  };
  
  if (get(user, 'callingAutomatically.status', CallingAutomaticallyStatus.Paused) === CallingAutomaticallyStatus.Active) {
    const serviceType = get(user, 'callingAutomatically.serviceType', '') || '';
    const serviceId = get(user, 'callingAutomatically.serviceId', '') || '';

    if (serviceType && serviceId) {
      const queueQuery = {[`${serviceType}Id`]: serviceId};

      QueueService.GetByIdAndType(serviceId, serviceType).then((queue) => {
        const placeId = get(queue, 'placeId', '') || '';

        if (placeId) {
          PlaceService.GetOneAsPromise(placeId).then((place) => {
            const organizationId = get(place, 'organizationId', '') || '';

            if (organizationId) {
              NotificationService.Success($translate.instant('redirecting to the service with automatic call activated'));

              const nowServingQueueParams = Object.assign({}, queueQuery, { placeId, organizationId });
              return $state.go(SAFE_STATES.nowServingQueue, nowServingQueueParams);
            } else {
              $scope.pauseUserCallingAutomatically();
            }
          }).catch(ErrorService.handler);
        } else {
          $scope.pauseUserCallingAutomatically();
        }
      }).catch(ErrorService.handler);
    } else {
      $scope.pauseUserCallingAutomatically();
    }
  } else {
    $scope.queryOrganizationAndPlace();
  }

  $scope.pauseUserCallingAutomatically = () => {
    const callingAutomatically = {
      status: CallingAutomaticallyStatus.Paused,
      reason: CallingAutomaticallyReason.NotValidData,
      serviceId: '',
      serviceType: '',
      userId,
    };

    UserService.UpdateCallingAutomaticallyStatus(userId, callingAutomatically);

    $scope.queryOrganizationAndPlace();
  };

  $scope.showPlaceSwitch = placeId => {
    const permissions = get(UserService.GetCurrent(), 'permissions', []) || [];
    return (permissions.map(permission => {
      const itsRole = rolesAllowedToEnableDisablePlace.indexOf(permission.role.name) > -1;
      const itsForPlace = permission.role.placeId === placeId
      return itsRole && itsForPlace;
    })).some(Boolean);
  }

  

  $scope.selectPlace = place => {
    $rootScope.$emit('place-join');

    if ($scope.disabledForPlace(place._id)) {
      return;
    }
    if (place.revertMigration) {
      RedirectToNewVersionService.Redirect('now-serving', place._id, $scope.currentUser._id, '').then();
    }
    UserService.GetCurrentAsPromise()
      .then(currentUser => {
        $timeout(() => {
          PlaceService.SetCurrent(place);
          const currentRole = UserService.GetCurrentRoleFor(currentUser);
          switch (currentRole.name) {
            case 'operator':
            case 'Admin General':
            case 'Coordinator':
              return $state.go(SAFE_STATES.nowServing, { placeId: place._id, organizationId: place.organizationId });
            case 'Receptionist':
            case 'Base Receptionist':
              return $state.go(SAFE_STATES.receptionWelcome, { placeId: place._id, organizationId: place.organizationId });
            case 'Statistical':
              return $state.go(SAFE_STATES.stats, { placeId: place._id, organizationId: place.organizationId });
            default:
              return $state.go(SAFE_STATES.nowServing, { placeId: place._id, organizationId: place.organizationId });
          }
        }, 1000);
      });
  };

  $scope.edit = placeId => $state.go(SAFE_STATES.placesEdit, { id: placeId });


  $scope.open = placeId => {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/places-modal.html',
      size: 'lg',
      controller: 'PlaceModalController',
      resolve: {
        placeId: () => placeId,
        organization: () => $scope.organization,
      }
    });

    modal.result.then(result => {
      if (result !== 'cancel') {
        const updatedPlace = result;

        for (const index in $scope.places) {
          if ($scope.places[index]._id === updatedPlace._id) {
            $scope.places[index] = updatedPlace;
          }
        }
      }
    })
  };

  $scope.disabledForPlace = placeId => UserService.DisabledForPlace(placeId);

  $scope.addAdvancedSearch = () => {
    $scope.showAdvancedSearch = !$scope.showAdvancedSearch;    
  };
  $scope.enabledForAppAndAgendaToggle = (place) => {
    const { _id } = place;
    const  enabledForAppAndAgenda  = get(place,'configuration.enabledForAppAndAgenda',false);
   PlaceService.EnabledForAppAndAgendaToggle(_id,enabledForAppAndAgenda); 
  };
};

module.exports = module.controller('PlacesListController', PlacesListController);
